import {z} from "zod"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {borderMode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/hal/convolve-helper-hal"

export const Kernel = z.object({
    width: z.number(),
    height: z.number(),
    values: z.array(z.number()), // row-major
})

export type Kernel = z.infer<typeof Kernel>

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            kernel: Kernel,
            borderMode: borderMode.optional().default("renormalize"),
        }),
    },
}
